import React, { Dispatch, FC, SetStateAction, useState } from "react";

import { IgCheckbox, IgTypography } from "@intelligems/ig-theme";
import {
  AnalyticsResourceType,
  AnalyticsViewType,
} from "@intelligems/ig-types";
import { FormControlLabel, Grid, ListItemButton } from "@mui/material";
import { styled } from "@mui/material/styles";

import { analyticsViewTypesList } from "../../domains/Dashboard/Utils/AnalyticsViewTypeList";
import { ExperienceFe } from "../../types/schemas/experiences";

const PREFIX = "AnalyticsViewTypeFilter";

const classes = {
  root: `${PREFIX}-root`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.root}`]: {
    transition: "0.2s",
    borderRadius: "4px",
    justifyContent: "center",
    border: `1px solid ${theme.palette.gray.light}`,
    "&:hover, &:focus": {
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
}));

interface AnalyticsViewTypeFilterProps {
  currentResource: ExperienceFe | undefined;
  isTestOrdersOnly: boolean;
  isTestProductsDefaultChange: boolean;
  setIsTestProductsDefaultChange: Dispatch<SetStateAction<boolean>>;
  resourceType: AnalyticsResourceType;
  onBooleanFilterChange: (
    checked: boolean,
    filterKey: "isTestOrdersOnly" | "isZScoreEnabled"
  ) => void;
}
export const AnalyticsViewTypeFilter = ({
  currentResource,
  isTestOrdersOnly,
  isTestProductsDefaultChange,
  setIsTestProductsDefaultChange,
  resourceType,
  onBooleanFilterChange,
}: AnalyticsViewTypeFilterProps) => {
  const [selectedViewType, setSelectedViewType] = useState<
    AnalyticsViewType | undefined
  >(isTestOrdersOnly ? "test_orders_only" : "sitewide_orders");

  const selectedCard = (viewType: string): boolean => {
    return selectedViewType === viewType;
  };

  const onSelect = (value: AnalyticsViewType) => {
    setSelectedViewType(value);
    onBooleanFilterChange(value === "test_orders_only", "isTestOrdersOnly");
  };

  if (currentResource) {
    return (
      <StyledGrid container spacing={2} direction={"row"}>
        {analyticsViewTypesList.slice(0, 2).map((viewType) => (
          <Grid item xs={6} key={viewType.key}>
            <ListItemButton
              classes={{ root: classes.root }}
              onClick={() => {
                onSelect(viewType.value as AnalyticsViewType);
              }}
              selected={selectedCard(viewType.value)}
            >
              <Grid container direction={"column"} alignItems={"center"}>
                <Grid item>
                  <IgTypography variant="body2" sx={{ fontWeight: 600 }}>
                    {viewType.key}
                  </IgTypography>
                </Grid>
              </Grid>
            </ListItemButton>
          </Grid>
        ))}

        {resourceType === "experiences" &&
          currentResource.experienceAnalysis.analyticsViewType !==
            selectedViewType &&
          !(
            currentResource.experienceAnalysis.analyticsViewType === "none" &&
            selectedViewType === "test_orders_only"
          ) && (
            <Grid item>
              <FormControlLabel
                control={
                  <IgCheckbox
                    checked={isTestProductsDefaultChange}
                    onChange={(event) => {
                      setIsTestProductsDefaultChange(event.target.checked);
                    }}
                  />
                }
                label={
                  <IgTypography variant={"body1"}>Set as Default</IgTypography>
                }
              />
            </Grid>
          )}
      </StyledGrid>
    );
  }
  return null;
};
